import APIconsume from 'Main/APIconsume'
import React, { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'

function AuthCookieVerification() {
  const [authStatus, setAuthStatus] = useState('checking') // 'checking' | 'authenticated' | 'unauthenticated'

  useEffect(() => {
    let isMounted = true
    const api = new APIconsume()

    const checkCookieSession = async () => {
      try {
        const { isValid } = await api.verifyCookieSession()

        if (isMounted) {
          setAuthStatus(isValid ? 'authenticated' : 'unauthenticated')
        }
      } catch (error) {
        if (isMounted) {
          setAuthStatus('unauthenticated')
        }
      }
    }

    checkCookieSession()

    return () => {
      isMounted = false
    }
  }, [])

  // 1. Show loading state while testing the cookie
  if (authStatus === 'checking') {
    return (
      <div className="artapay-session-checker">
        <div>
          <span className="artapay-session-spinner">
            <i className="fa-solid fa-circle-notch fa-spin" />
          </span>
        </div>
      </div>
    )
  }

  // 2. Cookie is valid -> redirect to dashboard
  if (authStatus === 'authenticated') {
    return <Navigate to="/dashboard" replace />
  }

  // 3. Unauthorized or no cookie -> redirect to login
  return <Navigate to="/auth/login" replace />
}

export default AuthCookieVerification
